import { useAuthStore } from '@/store/authStore';

export function useAuth() {
  const { user, isAuthenticated, isLoading, status, login, logout, checkAuth } = useAuthStore();

  return {
    user,
    isAuthenticated,
    isLoading,
    status,
    login,
    logout,
    checkAuth,
  };
}
